<div class="mt-10px flex flex-col sm:flex-row justify-center xs:justify-start">
    <div class="flex-auto" style="max-height: 300px">
        <mat-form-field class="w-full" appearance="outline" [ngClass]="{ 'mat-form-field-warn': showWarning }">
            <input
                matInput
                [id]="id"
                [name]="id"
                [formControl]="control"
                type="text"
                class="header-small"
                [class.gas-input-spacing]="useInputSpacing"
                autocomplete="off"
                [mask]="mask"
                [specialCharacters]="[]"
                [separatorLimit]="allowDecimals && useDecimalMask ? separatorLimit : ''"
                [placeholder]="placeholder"
            />

            @if (unit) {
                <span class="header-x-small whitespace-nowrap tracking-tightest" matSuffix>
                    {{ unitText }} <sup>{{ unitSuperindex }}</sup>
                </span>
            }

            @if (showWarning) {
                <mat-hint>
                    <div class="body-small-header text-orange small" [innerHTML]="deviationText"></div>
                </mat-hint>
            } @else if (hint && hint.length > 0) {
                <mat-hint>
                    <div class="body-small input-help" [innerHTML]="hint"></div>
                </mat-hint>
            }

            @for (err of errors; track err) {
                <mat-error class="">
                    <span class="body-small-header">{{ err }}</span>
                </mat-error>
            }
        </mat-form-field>
    </div>

    <div
        class="flex-row w-full justify-center sm:w-1/2 sm:justify-start pt-10px sm:pt-0"
        [ngClass]="{ flex: showSample, hidden: !showSample }"
    >
        <div class="reading-sample w-285px sm:max-w-100pct mt-20px xs:mt-0 xs:px-20px">
            <mat-icon inline="true" svgIcon="evida_gas_counter"></mat-icon>
        </div>
    </div>
</div>
